export default __webpack_public_path__ + "static/media/hht1_storybook_13.9cc92006.png";